<template>
  <div ref="dialogCon" class="dialog-con">
    <div class="content">
      <div class="content-top">
        <slot name="dialogTop">
        </slot>
        <div @click="close">
          <svg-icon icon-class="close"></svg-icon>
        </div>
      </div>
      <div class="slot-div">
        <slot name="dialogContent">
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Dialog",
    mounted() {
      this.$refs.dialogCon.addEventListener('click', (event) => {
        if (event.target.classList[0] === 'dialog-con') {
          this.$emit('close')
        }
      })
    },
    methods: {
      close() {
        this.$emit('close')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .dialog-con {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;

    background-color: rgba(0, 0, 0, .7);
    color: #000;

    .content {
      position: absolute;
      left: 0;
      bottom: 0;
      right: 0;
      height: calc(100vh - 134px);

      border-radius: 30px 30px 0 0;
      background-color: #fff;

      .content-top {
        height: 114px;
        line-height: 114px;
        font-size: 30px;
        color: #21252D;
        text-align: center;
        border-bottom: 1px solid #F3F4F5;
      }

      .slot-div {
        height: calc(100% - 57px);
        overflow-y: auto;
      }

      .svg-icon {
        position: absolute;
        right: 40px;
        top: 40px;

        fill: #ccc;
      }
    }
  }
</style>